// ヒーロー下バナー（Figma PC 4390:15663 / SP 4420:4040）
// PCは 600px を中央寄せして両脇を覗かせる。SPは全幅1枚。
// 先頭・末尾クローンで無限ループ。左右どちらにもスワイプできる。
const PC_MQ = '(min-width: 769px)';
const SP_MQ = '(max-width: 768px)';
const START_PX = 4;
const SNAP_PX = 24;
const SNAP_RATIO = 0.08;
const VELOCITY = 0.3;

const main = () => {
    const slider = document.querySelector('.js-banner-slider');
    if (!slider) return;
    const track = slider.querySelector('.js-banner-track');
    if (!track) return;

    const originals = Array.from(track.querySelectorAll('.p-home-banner__slide'));
    const dots = document.querySelectorAll('.js-banner-dots .p-home-banner__dot');
    const realCount = originals.length;
    if (realCount <= 1) return;

    const warmUrl = (url) => {
        if (!url) return Promise.resolve();
        return new Promise((resolve) => {
            const img = new Image();
            img.decoding = 'async';
            img.onload = () => {
                if (typeof img.decode === 'function') {
                    img.decode().then(resolve).catch(resolve);
                    return;
                }
                resolve();
            };
            img.onerror = resolve;
            img.src = url;
        });
    };

    const slideImgUrl = (slide) => {
        if (!slide) return '';
        const img = slide.querySelector('.p-home-banner__image');
        if (img?.currentSrc) return img.currentSrc;
        const useSp = window.matchMedia(SP_MQ).matches;
        const fromData = useSp ? slide.dataset.bannerSp : slide.dataset.bannerPc;
        if (fromData) return fromData;
        return img?.getAttribute('src') || '';
    };

    const applySlideBg = (slide) => {
        const url = slideImgUrl(slide);
        if (!url) return Promise.resolve();
        if (slide.dataset.slideBg === url) return warmUrl(url);
        slide.style.backgroundImage = `url("${url}")`;
        slide.dataset.slideBg = url;
        return warmUrl(url);
    };

    const prepareClone = (sourceSlide) => {
        const url = slideImgUrl(sourceSlide);
        const sourceLink = sourceSlide.querySelector('.p-home-banner__link:not(.js-home-popup-open)');
        const clone = document.createElement(sourceLink ? 'a' : 'div');
        clone.className = 'p-home-banner__slide p-home-banner__slide--clone';
        clone.setAttribute('aria-hidden', 'true');
        if (sourceLink) {
            clone.href = sourceLink.getAttribute('href');
            clone.tabIndex = -1;
        }
        if (url) {
            clone.style.backgroundImage = `url("${url}")`;
            clone.dataset.cloneSrc = url;
        }
        return clone;
    };

    const syncCloneBg = (clone, sourceSlide) => {
        if (!clone || !sourceSlide) return Promise.resolve();
        const url = slideImgUrl(sourceSlide);
        if (!url || clone.dataset.cloneSrc === url) return warmUrl(url);
        clone.style.backgroundImage = `url("${url}")`;
        clone.dataset.cloneSrc = url;
        return warmUrl(url);
    };

    const firstClone = prepareClone(originals[0]);
    const lastClone = prepareClone(originals[realCount - 1]);
    // PC両脇覗き用。ループ境界のクローンの隣に「次/前」の実スライドが無いと
    // teal 背景だけ見えてから画像が遅れて出る（3→1は右覗き、1→3は左覗き）。
    const peekSource = realCount > 1 ? originals[1] : null;
    const leftPeekClone = peekSource ? prepareClone(peekSource) : null;
    const rightPeekClone = peekSource ? prepareClone(peekSource) : null;

    track.insertBefore(lastClone, originals[0]);
    if (leftPeekClone) track.insertBefore(leftPeekClone, lastClone);
    track.appendChild(firstClone);
    if (rightPeekClone) track.appendChild(rightPeekClone);
    originals.forEach((slide) => applySlideBg(slide));

    // [左2枚目C?][最後C][実×N][先頭C][右2枚目C?] — 実スライド先頭の track 添字
    const HEAD_OFFSET = leftPeekClone ? 2 : 1;
    const lastCloneIndex = HEAD_OFFSET - 1;
    const firstCloneIndex = HEAD_OFFSET + realCount;

    const preloadUrls = new Set();
    originals.forEach((slide) => {
        if (slide.dataset.bannerPc) preloadUrls.add(slide.dataset.bannerPc);
        if (slide.dataset.bannerSp) preloadUrls.add(slide.dataset.bannerSp);
    });

    const slides = Array.from(track.querySelectorAll('.p-home-banner__slide'));
    let trackIndex = HEAD_OFFSET;
    let timer = null;
    let jumpTimer = null;
    let animating = false;
    const AUTO_MS = Number(slider.dataset.interval) || 3000;
    const TRANSITION_MS = 350;
    const JUMP_FALLBACK_MS = TRANSITION_MS + 50;
    const CLICK_SLOP_PX = 5;

    let pointerId = null;
    let startX = 0;
    let startY = 0;
    let startAt = 0;
    let dragDx = 0;
    let dragging = false;
    let axisLocked = null;
    let suppressClick = false;

    const isPc = () => window.matchMedia(PC_MQ).matches;
    const isCloneIndex = (index) => index === lastCloneIndex || index === firstCloneIndex;

    const getStep = () => {
        const style = window.getComputedStyle(track);
        const gap = parseFloat(style.columnGap || style.gap) || 0;
        return slides[0].getBoundingClientRect().width + gap;
    };

    const baseOffset = () => {
        const step = getStep();
        if (isPc()) {
            const containerW = slider.clientWidth;
            const slideW = slides[0].getBoundingClientRect().width;
            return (containerW - slideW) / 2 - trackIndex * step;
        }
        return -trackIndex * step;
    };

    const realIndex = () => {
        if (trackIndex <= lastCloneIndex) return realCount - 1;
        if (trackIndex >= firstCloneIndex) return 0;
        return trackIndex - HEAD_OFFSET;
    };

    const setTransform = (withTransition, extra = 0) => {
        track.style.transition = withTransition ? `transform ${TRANSITION_MS}ms ease` : 'none';
        track.style.transform = `translateX(${baseOffset() + extra}px)`;
    };

    const syncDots = () => {
        const ri = realIndex();
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === ri));
    };

    const clearJumpTimer = () => {
        if (jumpTimer) window.clearTimeout(jumpTimer);
        jumpTimer = null;
    };

    const jumpIfClone = () => {
        clearJumpTimer();
        if (trackIndex === lastCloneIndex) {
            trackIndex = HEAD_OFFSET + realCount - 1;
            applySlideBg(originals[realCount - 1]);
            setTransform(false);
            void track.offsetHeight;
        } else if (trackIndex === firstCloneIndex) {
            trackIndex = HEAD_OFFSET;
            applySlideBg(originals[0]);
            setTransform(false);
            void track.offsetHeight;
        }
        settle();
    };

    const scheduleJumpIfClone = (index) => {
        clearJumpTimer();
        if (!isCloneIndex(index)) return;
        jumpTimer = window.setTimeout(jumpIfClone, JUMP_FALLBACK_MS);
    };

    let autoplayPaused = false;

    const stop = () => {
        if (timer) window.clearTimeout(timer);
        timer = null;
    };

    const canAutoplay = () => !autoplayPaused && !dragging && !document.hidden;

    const armAutoplay = () => {
        stop();
        if (!canAutoplay()) return;
        timer = window.setTimeout(() => {
            timer = null;
            if (!canAutoplay() || animating) return;
            goToTrack(trackIndex + 1, true);
        }, AUTO_MS);
    };

    const settle = () => {
        animating = false;
        if (canAutoplay()) armAutoplay();
    };

    const goToTrack = (nextTrackIndex, withTransition = true) => {
        const clamped = Math.max(lastCloneIndex, Math.min(firstCloneIndex, nextTrackIndex));
        stop();
        trackIndex = clamped;
        animating = withTransition;
        setTransform(withTransition);
        syncDots();
        if (!withTransition) {
            settle();
            return;
        }
        scheduleJumpIfClone(clamped);
    };

    const goReal = (realIdx) => {
        const clamped = ((realIdx % realCount) + realCount) % realCount;
        goToTrack(clamped + HEAD_OFFSET, true);
    };

    const syncAllCloneBg = () => Promise.all([
        syncCloneBg(firstClone, originals[0]),
        syncCloneBg(lastClone, originals[realCount - 1]),
        peekSource ? syncCloneBg(leftPeekClone, peekSource) : Promise.resolve(),
        peekSource ? syncCloneBg(rightPeekClone, peekSource) : Promise.resolve(),
    ]);

    track.addEventListener('transitionend', (e) => {
        if (e.target !== track || e.propertyName !== 'transform') return;
        if (isCloneIndex(trackIndex)) {
            jumpIfClone();
            return;
        }
        clearJumpTimer();
        settle();
    });

    const endDrag = () => {
        if (pointerId === null) return;

        slider.classList.remove('is-dragging');

        const step = getStep() || 1;
        const elapsed = Math.max(1, Date.now() - startAt);
        const velocity = dragDx / elapsed;
        const lockedAxis = axisLocked;
        const dx = dragDx;
        const shouldSlide =
            lockedAxis === 'x'
            && (
                Math.abs(dx) > Math.max(SNAP_PX, step * SNAP_RATIO)
                || Math.abs(velocity) > VELOCITY
            );

        if (Math.abs(dx) > CLICK_SLOP_PX) suppressClick = true;

        // pointerup では暗黙に解放されるが、pointercancel 経由や
        // 途中でキャプチャを取っていない場合もあるので明示的に戻す
        if (slider.hasPointerCapture?.(pointerId)) slider.releasePointerCapture?.(pointerId);

        dragging = false;
        dragDx = 0;
        axisLocked = null;
        pointerId = null;

        if (shouldSlide) {
            goToTrack(trackIndex + (dx < 0 ? 1 : -1), true);
        } else if (lockedAxis === 'x') {
            stop();
            animating = true;
            setTransform(true);
        } else {
            armAutoplay();
        }
    };

    slider.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (e.target.closest('.p-home-banner__dot-btn')) return;

        clearJumpTimer();
        pointerId = e.pointerId;
        startX = e.clientX;
        startY = e.clientY;
        startAt = Date.now();
        dragDx = 0;
        dragging = true;
        axisLocked = null;
        suppressClick = false;
        animating = false;
        stop();
        // ここで setPointerCapture してはいけない。ポインタキャプチャ中は click が
        // キャプチャ要素（このスライダー）へ再ターゲットされ、中の <a> に届かなくなる。
        // 結果、都道府県版では遷移せず、総合版では県選択ポップアップも開かない
        // （ポップアップの click 監視は <a> 側に張ってあるため）。
        // 実際に横ドラッグが始まった時点＝pointermove で軸が x に確定してから捕まえる
    });

    slider.addEventListener('click', (e) => {
        if (!suppressClick) return;
        suppressClick = false;
        e.preventDefault();
        e.stopPropagation();
    }, true);

    // スライドは <a>（中は <img>）なので、PCで横に引っぱるとブラウザ標準の
    // リンク/画像ドラッグが始まり、スワイプが途中で奪われる。
    // pointermove の preventDefault では dragstart までは止まらないのでここで止める
    slider.addEventListener('dragstart', (e) => e.preventDefault());

    slider.addEventListener('pointermove', (e) => {
        if (!dragging || e.pointerId !== pointerId) return;

        const dx = e.clientX - startX;
        const dy = e.clientY - startY;

        if (!axisLocked) {
            if (Math.abs(dx) < START_PX && Math.abs(dy) < START_PX) return;
            axisLocked = Math.abs(dx) >= Math.abs(dy) ? 'x' : 'y';
            if (axisLocked === 'y') return;
            // 横ドラッグと確定した時点で捕まえる。以降は指がスライダーの外へ出ても
            // pointermove/pointerup が届く。クリック（＝ドラッグしていない操作）は
            // ここを通らないので、<a> がそのまま click を受け取れる
            slider.setPointerCapture?.(pointerId);
        }

        if (axisLocked !== 'x') return;
        e.preventDefault();
        dragDx = dx;
        slider.classList.add('is-dragging');
        setTransform(false, dragDx);
    }, { passive: false });

    slider.addEventListener('pointerup', (e) => {
        if (e.pointerId !== pointerId) return;
        endDrag();
    });

    slider.addEventListener('pointercancel', (e) => {
        if (e.pointerId !== pointerId) return;
        endDrag();
    });

    document.querySelectorAll('.js-banner-dots .p-home-banner__dot-btn').forEach((btn) => {
        btn.addEventListener('click', () => {
            goReal(Number(btn.dataset.index) || 0);
        });
    });

    slider.addEventListener('mouseenter', () => {
        autoplayPaused = true;
        stop();
    });
    slider.addEventListener('mouseleave', () => {
        autoplayPaused = false;
        if (!dragging && !animating) armAutoplay();
    });
    window.addEventListener('resize', () => {
        originals.forEach((slide) => applySlideBg(slide));
        syncAllCloneBg();
        setTransform(false);
        syncDots();
    });

    document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
            stop();
            clearJumpTimer();
            return;
        }
        jumpIfClone();
        setTransform(false);
        syncDots();
        if (!dragging) armAutoplay();
    });

    setTransform(false);
    syncDots();

    Promise.all([
        ...originals.map((slide) => applySlideBg(slide)),
        ...[...preloadUrls].map(warmUrl),
    ])
        .then(() => syncAllCloneBg())
        .finally(() => {
            const prevIndex = trackIndex;
            trackIndex = firstCloneIndex;
            setTransform(false);
            void firstClone.offsetHeight;
            if (rightPeekClone) void rightPeekClone.offsetHeight;
            trackIndex = lastCloneIndex;
            setTransform(false);
            void lastClone.offsetHeight;
            if (leftPeekClone) void leftPeekClone.offsetHeight;
            trackIndex = prevIndex;
            setTransform(false);
            armAutoplay();
        });
};

export default main;
